import React from 'react';

export default function SvgSpeakerFilled(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="currentColor"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.6255 14.5756C19.168 14.8418 18.5973 14.7327 18.2648 14.3433L12.3505 15.7948C12.868 17.2545 12.293 18.9278 10.9161 19.7292C9.36689 20.631 7.37719 20.0946 6.48202 18.5314C6.26745 18.1567 6.13252 17.7491 6.07752 17.3344L4.87489 17.6295C4.83246 17.9543 4.64608 18.2564 4.34313 18.4327C3.82588 18.7338 3.16372 18.5549 2.86509 18.0335L1.06176 14.8845C0.763131 14.363 0.940556 13.6955 1.4578 13.3944C1.76358 13.2164 2.12002 13.2062 2.42204 13.3353L11.9719 3.38427C11.7376 2.87742 11.9228 2.26453 12.4121 1.97969C12.9294 1.67862 13.5916 1.8575 13.8902 2.37897L14.2394 2.98875L14.2511 3.00877L19.7145 12.5489L19.7258 12.5692L20.0215 13.0855C20.3201 13.6069 20.1427 14.2745 19.6255 14.5756ZM10.2123 16.3196L8.21402 16.81C8.19368 17.0204 8.2409 17.2394 8.35537 17.4393C8.654 17.9608 9.31741 18.1389 9.83341 17.8386C10.3494 17.5383 10.5281 16.87 10.2302 16.3497C10.2243 16.3395 10.2183 16.3294 10.2123 16.3196Z"
        fill="#2A2A28"
      />
    </svg>
  );
}
